/** This file sets up auto saving used for both challenges and projects.
 */
import {t} from "@lingui/core/macro";
import _ from "underscore";

import $ from "#jquery/jquery-with-scratchpad-plugins.js";
import {PROGRAM_STATUS} from "#scratchpad-shared-package/types.ts";

const bindEvents: any = _.once(function (ScratchpadUI) {
    $(ScratchpadUI).bind({
        started: function (e) {
            if (!isChallengeOrProject()) {
                return;
            }

            // Used throughout the function
            const liveEditor = ScratchpadUI.liveEditor;
            const editor = liveEditor.editor;

            // Whenever the user changes code
            // - show the saving progress message
            // - call the throttled save progress function
            //   this will cause progress to be saved once
            //   the user stops typing for ~5 seconds
            editor.on("change", function () {
                $("#save-progress-text")
                    .stop(true)
                    .show()
                    .text(t`Saving progress...`);
                throttledSaveUserProgress();
            });
        },

        initCode: function (e, options) {
            if (isChallengeOrProject()) {
                options.code = ScratchpadUI.userScratchpad.get("stashedCode");
            }
        },

        remove: function () {
            if (isChallengeOrProject()) {
                saveUserProgress();
            }
        },

        beforeunload: function (e, options) {
            if (isChallengeOrProject()) {
                const code = ScratchpadUI.liveEditor.editor.text();
                if (code !== ScratchpadUI.userScratchpad.get("stashedCode")) {
                    options.warnMsg = options.defaultMsg;
                }
            }
        },
    });

    const isChallengeOrProject = function () {
        return (
            ScratchpadUI.scratchpad.isChallenge() ||
            ScratchpadUI.scratchpad.isProject()
        );
    };

    /*
     * Displays a save status message to the user
     */
    const showSaveStatus = function (text: string) {
        ScratchpadUI.$el.find("#save-progress-text").text(text);
    };

    /*
     * Saves challenge progress to the UserScratchpad.
     *
     * If otherAttrs is specified, those will be saved along with the challenge
     * progress. This is used to avoid doing two XHR calls simultaneously to update
     * two properties of the same UserScratchpad.
     */
    const saveUserProgress = function (otherAttrs?: Record<string, any>) {
        let attrs: Record<string, any> = {};

        // Update the Program's challenge status to STARTED if necessary.
        const currentChallengeStatus =
            ScratchpadUI.userScratchpad.get("challengeStatus");
        if (
            currentChallengeStatus === PROGRAM_STATUS.CHALLENGE_NOT_STARTED ||
            currentChallengeStatus === PROGRAM_STATUS.PROJECT_NOT_STARTED
        ) {
            attrs = {
                challengeStatus: ScratchpadUI.scratchpad.isProject()
                    ? PROGRAM_STATUS.PROJECT_STARTED
                    : PROGRAM_STATUS.CHALLENGE_STARTED,
            };
        }

        const options = {
            success: function () {
                showSaveStatus(t`All changes saved.`);
            },
            error: function () {
                showSaveStatus(t`Failed to save changes.`);
            },
            attrs: {...attrs, ...otherAttrs},
        } as const;
        ScratchpadUI.stashUserCode(options);
    };

    const throttledSaveUserProgress = _.debounce(saveUserProgress, 3000);
});

export default {
    bindEvents,
};
